import React from 'react';
import xsmallLoader from '../../assets/loader-xs.svg';
import inputLoader from '../../assets/input-loader.svg';
import { withRouter } from 'react-router-dom';
import {baseUrl} from '../url';

class CaregiverForm extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            userType: this.props.userType,
            prefix: '',
            first_name: '',
            last_name: '',
            alias: '',
            phone_no: '',
            email: '',
            prefixError: '',
            first_nameError: '',
            last_nameError: '',
            aliasError: '',
            phone_no8Error: '',
            emailError: '',
            noResponse: true,

            aliasResponse: true,
            phone_noResponse: true,
            emailResponse: true,
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }
    handleChange(e){
        this.setState({ 
            [e.target.name]: e.target.value,
            [e.target.name + 'Error']: ''
        });
        if(e.target.name === 'alias'){
            const re = /^[\w.,-]+$/;
            if(!re.test(e.target.value)){
                this.setState({
                    aliasError: "Please no spaces or special characters"
                })
            }
        }
        if(e.target.name === 'phone_no'){
            if(e.target.value.length >= 11){
                if(!/(0[7-9][01])\d{8}/.test(e.target.value)){
                    this.setState({
                        phone_noError: 'Please enter a valid phone number'
                    })
                }
            }
        }
        if((e.target.name === 'alias' || e.target.name === 'email' || e.target.name === 'phone_no') && e.target.value.length > 0){
            this.checkUnique(e.target.name, e.target.value);
        }
    }
    checkUnique(item, value){
        if(item === 'alias'){
            this.setState({
                aliasResponse: false
            })
        }
        if(item === 'email'){
            this.setState({
                emailResponse: false
            })
        }
        if(item === 'phone_no'){
            this.setState({
                phone_noResponse: false
            })
        }
        const token = localStorage.getItem('access_token');
        fetch(`${baseUrl}/unique?item=${item}&value=${value}`,{
            method: 'GET',
            headers: {
                'Authorization': token
            }
        })
        .then((response) => {
            console.log(response)
            if(item === 'alias'){
                this.setState({
                    aliasResponse: true
                })
            }
            if(item === 'email'){
                this.setState({
                    emailResponse: true
                })
            }
            if(item === 'phone_no'){
                this.setState({
                    phone_noResponse: true
                })
            }
            if(response.status === 409){
                if(item === 'alias'){
                    this.setState({
                        aliasError: 'Alias is already in use.'
                    })
                }
                else if(item === 'phone_no'){
                    this.setState({
                        phone_noError: 'Phone number is already in use.'
                    })
                }
                else if(item === 'email'){
                    this.setState({
                        emailError: 'Email is already in use.',
                        emailResponse: true
                    })
                }
            }
        })
    }
    handleSubmit=(e)=>{
        e.preventDefault();
        const {prefix, first_name , last_name, alias, phone_no, email, userType} = this.state;

        if(!prefix){
            this.setState({
                prefix: 'Please select one'
            })
        }
        if(!first_name){
            this.setState({
                first_nameError: 'This field cannot be empty'
            })
        }
        if(!last_name){
            this.setState({
                last_nameError: 'This field cannot be empty'
            })
        }
        if(!alias){
            this.setState({
                aliasError: 'This field cannot be empty'
            })
        }
        if(!phone_no){
            this.setState({
                phone_noError: 'This field cannot be empty'
            })
        }
        if(!email){
            this.setState({
                emailError: 'This field cannot be empty'
            })
        }
        if(prefix && first_name && last_name && phone_no && alias && email){
            console.log(prefix, first_name , last_name, alias, phone_no, email, userType);
            this.setState({
                noResponse: false
            })
            
            let formData = new FormData(e.target);

            let retries = 0;

            const token = localStorage.getItem('access_token');

            fetch(`${baseUrl}/admin/users/create`,{
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Authorization': token
                }, 
                body: formData
            })
            .then((response) => {
                const auth = response.headers.get('Authorization');
                localStorage.setItem('access_token', auth);
                return response.json();
            })
            .then((responseJson) => {
                console.log(responseJson)
                if (responseJson.hasOwnProperty('message')){
                    if(responseJson.message === 'Caregiver successfully created.'){
                        let user_id = responseJson.caregiver.caregiver_id,
                            user_type = 'care_giver';
                        localStorage.setItem('user_type', user_type);
                        localStorage.setItem('user_id', user_id);

                        this.setState({
                            noResponse: true,
                        })
                        this.props.history.push(`/caregiver`);
                    }
                }
                if (responseJson.hasOwnProperty('errors')){
                    this.setState({
                        noResponse: true
                    })
                    if(responseJson.errors.phone_no){
                        this.setState({
                            phone_noError: responseJson.errors.phone_no
                        })
                    }
                    if(responseJson.errors.alias){
                        this.setState({
                            aliasError: responseJson.errors.alias
                        })
                    }
                    if(responseJson.errors.email){
                        this.setState({
                            emailError: responseJson.errors.email
                        })
                    }
                }
            })
            .catch((error)=>{
                if (error === 401 && retries < 1){
                    localStorage.getItem('access_token')
                    .then(value => {
                        fetch(`${baseUrl}/token/refresh`,{
                            headers: {
                                'Accept': 'application/json',
                                'Authorization': value
                            }
                        }).then(response => {
                            retries += 1;
                            if(response.status === 200){
                                localStorage.setItem('access_token', response.headers.get('Authorization'));
                                this.handleSubmit();
                            }
                            else{
                                alert('something went wrong please try again later');
                            }
                        })
                    })
                }
                else{
                    alert('something went wrong please try again later');
                }
            })
        }
    }
    render(){
        let { aliasResponse, emailResponse, phone_noResponse } = this.state;
        return(
            <form onSubmit={this.handleSubmit}>
                <input type="hidden" name="type" value={this.state.userType}/>
                <label>
                    Title
                    <select 
                        name="prefix" 
                        className={this.state.prefixError && 'error-input'} 
                        onChange={this.handleChange}
                        value={this.state.prefix}>
                        <option value="">Select...</option>
                        <option value="dr">Dr</option>
                        <option value="mr">Mr</option>
                        <option value="mrs">Mrs</option>
                        <option value="ms">Ms</option>
                    </select>
                    <span className="error-text">{this.state.prefixError}</span>
                </label>
                <label>
                    First Name
                    <input type="text" name="first_name" className={this.state.first_nameError && 'error-input'} onChange={this.handleChange}/>
                    <span className="error-text">{this.state.first_nameError}</span>
                </label>
                <label>
                    Last Name
                    <input type="text" name="last_name" className={this.state.last_nameError && 'error-input'} onChange={this.handleChange}/>
                    <span className="error-text">{this.state.last_nameError}</span>
                </label>
                <label>
                    Alias
                    <input type="text" name="alias" className={this.state.aliasError && 'error-input'} onChange={this.handleChange}/>
                    {!aliasResponse && <img src={inputLoader} alt='' className='input-loader'/>}
                    <span className="error-text">{this.state.aliasError}</span>
                </label>
                <label>
                    Phone Number
                    <input type="number" name="phone_no" className={this.state.phone_noError && 'error-input'} onChange={this.handleChange}/>
                    {!phone_noResponse && <img src={inputLoader} alt='' className='input-loader'/>}
                    <span className="error-text">{this.state.phone_noError}</span>
                </label>
                <label>
                    Email
                    <input type="email" name="email" className={this.state.emailError && 'error-input'} onChange={this.handleChange}/>
                    {!emailResponse && <img src={inputLoader} alt='' className='input-loader'/>}
                    <span className="error-text">{this.state.emailError}</span>
                </label>
                <button type="submit" className="btn btn-green-full">Create User</button>
                {!this.state.noResponse && <div className="loader"><img src={xsmallLoader} alt=''/></div>}
            </form>
        )
    }
}

export default withRouter(CaregiverForm);


// WEBPACK FOOTER //
// ./src/components/addUser/CaregiverForm.js